const availableOffers = window.HONDAPS_AVAILABLE_OFFERS || {};

export const MAPPING = {
  labels: availableOffers.labels,
  endpoints: availableOffers.endpoints,
  data: availableOffers.data,
};

export const MODULE_NAME = 'available offers';